import initialState from './initial.state';
import * as types from '../actions/types.action';

/**
 * The related-products strip under a short or empty search (graph-product-search
 * relatedProducts). Cleared as soon as a new search starts, so a strip never outlives the search
 * it was for; SearchPage also checks parentSearchId against the search on screen, because a slow
 * response can still land after the next search has begun.
 */
export default function relatedProductsReducer(
  state = initialState.relatedProducts,
  action
) {
  switch (action.type) {
    case types.GET_RELATED_PRODUCTS_SUCCESS:
      return {
        parentSearchId: action.parentSearchId || null,
        searchId: action.searchId || null,
        strategy: action.strategy || null,
        title: action.title || null,
        searchedFor: action.searchedFor || null,
        results: action.results || [],
      };
    case types.GET_SEARCH_RESULTS_REQUESTED:
    case types.GET_SEARCH_RESULTS_FAILED:
    case types.GET_RELATED_PRODUCTS_REQUESTED:
    case types.GET_RELATED_PRODUCTS_FAILED:
      return initialState.relatedProducts;
    default:
      return state;
  }
}
